import Api from "../../utils/config/api";
import { toastr } from "react-redux-toastr";
import {
  SET_CAMPAIGN_TEMPLATE,
  RESET_CAMPS,
  SET_CAMP_STATE,
  SET_TOTAL_CUSTOMERS,
  SET_SMS_CREDITS,
  SET_EMAIL_CREDITS,
  RESET_CAMP_STATE,
  SET_CAMP_LIST,
  SET_CAMP_DETAIL,
  SET_CAMP_PERF_OVERVIEW,
  SET_CAMP_SHORTLINK,
  SET_DRAFT_CAMPAIGNS,
  INITIALIZE_CAMP_STATE,
  SET_TEST_CAMP_SENT,
  SET_CAMPAIGNS_CUSTOMERS,
  SET_WA_CREDITS,
  SET_EXISTING_CAMPAIGNS,
} from "../types";
import { setDraftAutoCampaigns } from "./autoEngageActions";

export const getCampaignTemplatesCall = (store_id, queries) => () => {
  return new Promise((resolve, reject) => {
    Api.get(
      `/v2/campaigns/templates/${store_id}?page=${queries?.page || 1}&limit=${
        queries?.limit || 6
      }${queries?.type ? `&type=${queries?.type}` : ""}${
        queries?.objective ? `&objective=${queries?.objective}` : ""
      }${
        queries?.is_whatsapp_enable
          ? `&is_whatsapp_enable=${queries?.is_whatsapp_enable}`
          : ""
      }`
    )
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const setCurrentCampaignCall = (data) => (dispatch) => {
  dispatch({
    type: SET_CAMPAIGN_TEMPLATE,
    payload: data,
  });
};

export const setDraftCampFrmHome = (camp) => (dispatch) => {
  dispatch({
    type: INITIALIZE_CAMP_STATE,
    payload: camp,
  });
};

export const setCampState = (data) => (dispatch) => {
  dispatch({
    type: SET_CAMP_STATE,
    payload: data,
  });
};

export const initializeCampaign = (storeId, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/campaigns/${storeId}`, data)
      .then((res) => {
        dispatch(setCampState(res?.data?.payload));

        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

export const createCampaignCall = (storeID, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/campaigns/${storeID}`, data)
      .then((res) => {
        dispatch(setCampState(res?.data?.payload));

        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const editCampaignCall = (campId, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.put(`/v1/campaigns/${campId}`, data)
      .then((res) => {
        dispatch(setCampState(res?.data?.payload));

        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const setCampImgCall = (storeID, campID, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.patch(`/v1/campaigns/${campID}/banner/${storeID}`, data)
      .then((res) => {
        dispatch(setCampState(res?.data?.payload));

        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

export const setRewardsCall = (storeId, campID, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.patch(`/v1/campaigns/${campID}/reward/${storeId}`, data)
      .then((res) => {
        dispatch(setCampState(res?.data?.payload));

        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

export const getUploadedImageLink = (data) => () => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/utility/file-link-upload`, data)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

export const testContentModeration = (data, contentType) => () => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/utility/moderation/${contentType}`, data)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

export const setTermsCall = (storeID, campID, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.patch(`/v1/campaigns/${campID}/terms/${storeID}`, data)
      .then((res) => {
        dispatch(setCampState(res?.data?.payload));

        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

export const setCampChannelOption =
  (channel, entityId, campID, data) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.patch(`/v1/campaigns/${campID}/${channel}/option/${entityId}`, data)
        .then((res) => {
          dispatch(setCampState({ ...res?.data, whatsapp_option: data.type }));
          return resolve(res?.data);
        })
        .catch((err) => {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err);
        });
    });
  };

export const setCampMsgCall =
  (channel, entityId, campID, data) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.patch(`/v1/campaigns/${campID}/${channel}/message/${entityId}`, data)
        .then((res) => {
          dispatch(setCampState(res?.data?.payload));

          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );

          return reject(err);
        });
    });
  };

export const fetchCampaignStatus =
  (
    channel,
    entityId,
    campID,
    isReminderActive,
    isAutoCampaign,
    isAutoCampPublished
  ) =>
  (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.get(
        `/v1/campaigns/${campID}/${channel}/custom/template/${entityId}/status`
      )
        .then((res) => {
          const data = res?.data?.payload?.data;
          if (!isAutoCampPublished) {
            if (
              data?.whatsapp?.dlt_template_id &&
              data?.whatsapp?.custom_sender_id &&
              data?.whatsapp?.content?.length > 0
            ) {
              data.status = "approved";
            } else if (data?.whatsapp?.reason) {
              data.status = "rejected";
              data.reason = data?.whatsapp?.reason;
            } else data.status = "pending";
          }

          if (isReminderActive) {
            if (
              data?.whatsapp_reminder?.dlt_template_id &&
              data?.whatsapp_reminder?.custom_sender_id &&
              data?.whatsapp_reminder?.content?.length > 0
            ) {
              data.whatsapp_reminder.status = "approved";
            } else if (data?.whatsapp_reminder?.reason) {
              data.whatsapp_reminder.status = "rejected";
            } else data.whatsapp_reminder.status = "pending";
          }

          isAutoCampaign
            ? dispatch(setDraftAutoCampaigns(data))
            : dispatch(setCampState(data));
          return resolve(data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  };

export const instantApprovalForCustomTemplate =
  (channel, entityId, campID) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.patch(
        `v1/campaigns/${campID}/${channel}/custom/template/${entityId}/submit`,
        {}
      )
        .then((res) => {
          dispatch(setCampState(res?.data?.payload));
          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          return reject(err.response.data.message);
        });
    });
  };

export const notifySupportForApproval =
  (channel, entityId, campID, data) => () => {
    return new Promise((resolve, reject) => {
      Api.patch(
        `/v1/campaigns/${campID}/${channel}/custom/approval/${entityId}`,
        data
      )
        .then((res) => {
          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  };

export const approveCustomSmsTemplate =
  (channel, entityID, campID, data, code, isWaReminder) => () => {
    return new Promise((resolve, reject) => {
      Api.patch(
        `/v1/campaigns/${campID}/${channel}/custom/approval/${entityID}/${code}${
          isWaReminder ? "?reminder=true" : ""
        }`,
        data
      )
        .then((res) => {
          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );

          return reject(err);
        });
    });
  };

export const getSmsPreviewForApproval = (approvalCode) => () => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/utility/shortlink/${approvalCode}`)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const submitToGupshup =
  (channel, entityID, campID, code, isWaReminder) => () => {
    return new Promise((resolve, reject) => {
      Api.patch(
        `/v1/campaigns/${campID}/${channel}/custom/approval/${entityID}/${code}/submit${
          isWaReminder ? "?reminder=true" : ""
        }`
      )
        .then((res) => {
          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );

          return reject(err);
        });
    });
  };

export const testPendingCampaigns = (
  campaignId,
  channel,
  entityId,
  shortCode,
  data,
  isWaReminder
) => {
  return new Promise((resolve, reject) => {
    Api.patch(
      `/v1/campaigns/${campaignId}/${channel}/custom/approval/${entityId}/${shortCode}/test${
        isWaReminder ? "?reminder=true" : ""
      }`,
      data
    )
      .then((res) => {
        toastr.success("Success", "Message Sent!!!");
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        let errMsg = "";

        if (err?.response?.status === 422) {
          const errArr = err?.response?.data?.errors?.map(
            (errObj) => errObj?.msg || ""
          );
          errMsg = errArr?.join(", ");
        } else {
          errMsg = `Reason: ${err?.response?.data?.message}`;
        }

        toastr.error("Failed to test template", errMsg);
        return reject(err);
      });
  });
};

export const getShortLinkCall = (storeID, campID) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/campaigns/${campID}/shortlink/${storeID}`)
      .then((res) => {
        dispatch({
          type: SET_CAMP_SHORTLINK,
          payload: res?.data?.payload?.link,
        });
        return resolve(res?.data?.payload?.link);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const setAudienceCall =
  (storeID, campID, data, clusterId) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.patch(
        `/v1/campaigns/${campID}/audience/${storeID}${
          clusterId ? `?cluster_id=${clusterId}` : ""
        }`,
        data
      )
        .then((res) => {
          dispatch(setCampState(res?.data?.payload));

          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err);
        });
    });
  };

export const setTotalCustomers = (customers) => (dispatch) => {
  dispatch({
    type: SET_TOTAL_CUSTOMERS,
    payload: customers,
  });
};

export const sndTestCampaignCall =
  (storeID, campID, data, reminder, isCache) => () => {
    return new Promise((resolve, reject) => {
      Api.post(
        `/v1/campaigns/${campID}/campaign/${storeID}/test${
          reminder ? "?reminder=true" : ""
        }${isCache ? `${reminder ? "&" : "?"}cache=true` : ""}`,
        data
      )
        .then((res) => {
          toastr.success("Test message sent successfully");
          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          if (err?.response?.status === 422) {
            err?.response?.data?.errors?.map((errObj) =>
              toastr.error(errObj.msg)
            );
            return reject(err?.response?.data?.errors);
          } else {
            toastr.error(
              "Error",
              err?.response?.data?.message || "Something went wrong!"
            );

            return reject(err?.response?.data?.message);
          }
        });
    });
  };

export const setChannelCall = (storeID, campID, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.patch(`/v1/campaigns/${campID}/channels/${storeID}`, data)
      .then((res) => {
        dispatch(setCampState(res?.data?.payload));

        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

export const setWaCreditsReq = (credits) => (dispatch) => {
  dispatch({
    type: SET_WA_CREDITS,
    payload: credits,
  });
};
export const setEmailCreditsReq = (credits) => (dispatch) => {
  dispatch({
    type: SET_EMAIL_CREDITS,
    payload: credits,
  });
};
export const setSmsCreditsReq = (credits) => (dispatch) => {
  dispatch({
    type: SET_SMS_CREDITS,
    payload: credits,
  });
};

export const setTestCampSent = (status) => (dispatch) => {
  dispatch({
    type: SET_TEST_CAMP_SENT,
    payload: status,
  });
};

export const setTimeScheduleCall = (storeID, campId, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.patch(`/v1/campaigns/${campId}/schedule/${storeID}`, data)
      .then((res) => {
        if (data?.cancelled) {
          dispatch(getCampListing(storeID, "", "", "", "", "", ""));
        } else {
          dispatch(setCampState(res?.data?.payload));
        }

        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

export const resetCamps = () => (dispatch) => {
  dispatch({
    type: RESET_CAMPS,
  });
};

export const resetCampState = () => (dispatch) => {
  dispatch({
    type: RESET_CAMP_STATE,
  });
};

const getCampTitle = (titleObj) => {
  return titleObj?.content?.replace(
    /{{(.+?)}}/g,
    (_, g1) => titleObj?.variables[g1] || g1
  );
};

export const getCampById = (campId, storeId, formatTags) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/campaigns/${campId}/store/${storeId}`)
      .then((res) => {
        let camp = res?.data?.payload;
        dispatch(
          setCurrentCampaignCall({
            index: 0,
            label: `${
              camp?.template_details?.objective?.value
            } - ${getCampTitle(camp?.template_details?.template?.title)}`,
            value: {
              ...camp?.template_details?.template,
              unique_id: camp?.template_details?.unique_id,
              label: camp?.template_details?.objective?.value,
              category: camp?.template_details?.objective?.key,
            },
          })
        );
        let duplicateCamp = { ...camp };
        duplicateCamp.id = duplicateCamp?._id;
        delete duplicateCamp?._id;
        delete duplicateCamp?.template_details;

        if (
          formatTags &&
          duplicateCamp?.audience?.filters?.customerTags?.length > 0
        ) {
          duplicateCamp.audience.filters.customerTags =
            duplicateCamp?.audience?.filters?.customerTags?.map(
              (tag) => tag?.id
            );
        }

        dispatch(setCampState(duplicateCamp));
        return resolve(duplicateCamp);
      })
      .catch((err) => {
        toastr.error(
          err?.response?.data?.message || "Error fetching Campaign Preview"
        );
        return reject(err);
      });
  });
};

export const getCampaignTemplateByAI = (campId, entityId, data) => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/campaigns/${campId}/store/${entityId}/text-generation`, data)
      .then((res) => resolve(res.data.payload))
      .catch((err) => {
        toastr.error(
          err?.response?.data?.message || "Error fetching Campaign Preview"
        );
        return reject(err);
      });
  });
};

// overview apis

export const getCampPerfOverview =
  (storeID, period, start, end) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.get(
        `/v1/insights/campaign/performance/${storeID}?${
          period &&
          `&period=${period}${start && `&start=${start}`}${
            end && `&end=${end}`
          }`
        }`
      )
        .then((res) => {
          dispatch({
            type: SET_CAMP_PERF_OVERVIEW,
            payload: res?.data?.payload,
          });
          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          toastr.error(
            err?.response?.data?.message ||
              "Error fetching Campaigns Performance"
          );
          return reject(err);
        });
    });
  };

export const getCampListing =
  (storeID, page, period, status, limit, start, end) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.get(
        `/v1/insights/campaigns/${storeID}?${page ? `page=${page}` : "page=1"}${
          period ? `&period=${period}` : ""
        }${status ? `&status=${status}` : ""}${
          limit ? `&limit=${limit}` : "&limit=5"
        }${start && `&start=${start}`}${end && `&end=${end}`}`
      )
        .then((res) => {
          dispatch({
            type: SET_CAMP_LIST,
            payload: res?.data?.payload,
          });
          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          toastr.error(
            err?.response?.data?.message || "Error fetching Campaigns Listings"
          );
          return reject(err);
        });
    });
  };

export const getCampDetail =
  (storeID, campId, start, end, showTags, showTiers, isRecommended) =>
  (dispatch) => {
    const url =
      start && end
        ? `/v1/insights/${campId}/overview/${storeID}?period=custom&start=${start}&end=${end}&show_tags=${showTags}&show_tiers=${showTiers}${
            isRecommended ? `&show_recommend_objective=true` : ""
          }`
        : `/v1/insights/${campId}/overview/${storeID}?show_tags=${showTags}${
            showTiers ? `&show_tiers=${showTiers}` : ""
          }${isRecommended ? `&show_recommend_objective=true` : ""}`;
    return new Promise((resolve, reject) => {
      Api.get(url)
        .then((res) => {
          dispatch({
            type: SET_CAMP_DETAIL,
            payload: res?.data?.payload,
          });
          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          toastr.error(
            err?.response?.data?.message || "Error fetching Campaigns Detail"
          );
          return reject(err);
        });
    });
  };

export const getCampaignsCustomer =
  (
    data,
    storeID,
    campId,
    limit,
    page,
    search,
    isAttachment,
    period,
    start,
    end
  ) =>
  (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.post(
        `/v1/insights/${campId}/audience/activity/${storeID}?${
          limit ? `limit=${limit}` : "limit=14"
        }${page ? `&page=${page}` : "&page=1"}${
          search ? `&search=${search}` : ""
        }&period=${period}&start=${start}&end=${end}${
          isAttachment ? "&attachment=true" : ""
        }`,
        data
      )
        .then((res) => {
          if (!isAttachment)
            dispatch({
              type: SET_CAMPAIGNS_CUSTOMERS,
              payload: res?.data?.payload,
            });

          return resolve(isAttachment ? res?.data : res?.data?.payload);
        })
        .catch((err) => {
          toastr.error(
            err?.response?.data?.message || "Error fetching Draft campaigns"
          );
          return reject(err);
        });
    });
  };

export const getDraftCampaigns =
  (data, entityId, page, limit) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.post(
        `/v1/campaigns/store/${entityId}${
          limit ? `?limit=${limit}` : "?limit=6"
        }${page ? `&page=${page}` : "&page=1"}`,
        data
      )
        .then((res) => {
          dispatch({
            type: SET_DRAFT_CAMPAIGNS,
            payload: res?.data?.payload,
          });
          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          toastr.error(
            err?.response?.data?.message || "Error fetching Draft campaigns"
          );
          return reject(err);
        });
    });
  };

export const getExistingCampaigns =
  (data, entityId, page, limit) => (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.post(
        `/v1/campaigns/store/${entityId}${
          limit ? `?limit=${limit}` : "?limit=6"
        }${page ? `&page=${page}` : "&page=1"}`,
        data
      )
        .then((res) => {
          dispatch({
            type: SET_EXISTING_CAMPAIGNS,
            payload: res?.data?.payload,
          });
          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          toastr.error(
            err?.response?.data?.message || "Error fetching Existing campaigns"
          );
          return reject(err);
        });
    });
  };

export const deleteDraftCampaigns = (storeId, campId) => () => {
  return new Promise((resolve, reject) => {
    Api.delete(`/v1/campaigns/${campId}/store/${storeId}`)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Failed to delete the draft."
        );
        return reject(err);
      });
  });
};

export const resetCampDetail = () => (dispatch) => {
  dispatch({
    type: SET_CAMP_DETAIL,
    payload: {},
  });
};

export const resetDraftCampaign = () => (dispatch) => {
  dispatch({
    type: SET_DRAFT_CAMPAIGNS,
    payload: {},
  });
};
